module.exports = __webpack_public_path__ + "img/104.7760e452.jpg";